import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cc7c420"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-content sticky-container" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "is-hidden-mobile" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "" }, "Total")
], -1))
const _hoisted_6 = {
  key: 0,
  class: "text-center"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 1 }

import { UseColumnsHelper } from "../../../Helper/Functional/UseColumnsHelper";
import { storeToRefs } from "pinia";
import { toRefs, computed } from "vue";

import {
  TAllTableHeaders,
  TAllTableHeaderValues,
} from "../../../../typings/DataFetching";
import { UseReportSettingsStore } from "../../State/Stores/ReportSettingsStore";
import { UseProgramStore } from "../../State/Stores/ProgramStore";
import { UseSegmentComparisonStore } from "../../State/Stores/SegmentComparisonStore";
import { UseStringHelper } from "../../../Helper/Functional/UseStringHelper";
import { UseSegmentComparisonState } from "../../../Pages/SegmentComparison/Hooks/UseSegmentComparisonState";
import { StaticSegmentStyleColumns } from "../../../StaticData/StaticSegmentStyleColumns";
import { UseTaxonomyHelper } from "../../../Helper/Stateful/UseTaxonomyHelper";

//Props

export default /*#__PURE__*/_defineComponent({
  props: {
    table: null
  },
  setup(__props: any) {

const props = __props as {
  table: {
    taxonomy: number;
    sortedTabled: Partial<TAllTableHeaderValues<TAllTableHeaders>>[];
    sortOrder: string;
    sortField: string;
    selectedColumns: string[];
  };
}



const { table } = toRefs(props);

const { getMetaTableColumns } = storeToRefs(UseReportSettingsStore());
const { getAvailablePrograms, getCurrentProgram } = storeToRefs(UseProgramStore());
const { getBottomName, getTopName } = storeToRefs(UseSegmentComparisonStore());

const currentProgram = computed(() =>
  getAvailablePrograms.value.find((prog) => prog.programcode === getCurrentProgram.value)
);
const {
  isColumnAvailable,
  isColumnVisible,
  calculateTotalsMetaTable,
  findAverageKey,
  headersKeyPairArray,
} = UseColumnsHelper();

const { convertNameToHandle } = UseStringHelper();

const { onSort } = UseSegmentComparisonState();

const { validateInternalParameter } = UseStringHelper();
const tabModel = 0;
const { columnSkeleton, footerSkeleton } = StaticSegmentStyleColumns();
const { fetchNavigationUrlHandler } = UseTaxonomyHelper();
const fetchNavigationUrl = computed(() =>
  fetchNavigationUrlHandler("/segment-comparison")
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_o_table_column = _resolveComponent("o-table-column")!
  const _component_performance_field = _resolveComponent("performance-field")!
  const _component_o_table = _resolveComponent("o-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_unref(table).sortedTabled.length)
          ? (_openBlock(), _createBlock(_component_o_table, {
              key: 0,
              class: "has-sticky-table-headers",
              ref: "metaTableTaxonomyOne",
              hoverable: "",
              data: _unref(table).sortedTabled,
              "backend-sorting": "",
              "default-sort-direction": _unref(table).sortOrder,
              "default-sort": [_unref(table).sortField, _unref(table).sortOrder],
              onSort: _unref(onSort)
            }, {
              footer: _withCtx(() => [
                _hoisted_5,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(footerSkeleton), (foot, i) => {
                  return (_openBlock(), _createElementBlock("th", {
                    class: _normalizeClass(["is-hidden-mobile text-center", {
                'hide-cell':
                  !_unref(isColumnVisible)(foot.field, _unref(getMetaTableColumns)) &&
                  _unref(isColumnAvailable)(
                    `first.${foot.field}`,
                    _unref(currentProgram)?.program_custom_reports[0].meta.excludedColumns || []
                  ),
              }]),
                    key: i
                  }, [
                    (foot.convert)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(calculateTotalsMetaTable)(
                    _unref(table).sortedTabled,
                    `${foot.field}_${_unref(convertNameToHandle)(
                      foot.asset === "bottomName" ? _unref(getBottomName) : _unref(getTopName)
                    )}`,
                    _unref(getBottomName),
                    _unref(getTopName),
                    _unref(findAverageKey)(
                      `${foot.field}_${_unref(convertNameToHandle)(
                        foot.asset === "bottomName" ? _unref(getBottomName) : _unref(getTopName)
                      )}`,
                      _unref(headersKeyPairArray)(_unref(getTopName), _unref(getBottomName)).value
                    )
                  )), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(calculateTotalsMetaTable)(
                    _unref(table).sortedTabled,
                    foot.field,
                    _unref(getBottomName),
                    _unref(getTopName),
                    _unref(findAverageKey)(
                      foot.field,
                      _unref(headersKeyPairArray)(_unref(getTopName), _unref(getBottomName)).value
                    )
                  )), 1))
                  ], 2))
                }), 128))
              ]),
              default: _withCtx(() => [
                _createVNode(_component_o_table_column, {
                  field: 'taxonomy_' + _unref(table).taxonomy,
                  label: 'Taxonomy ' + _unref(table).taxonomy,
                  sortable: "",
                  style: {"vertical-align":"center"}
                }, {
                  default: _withCtx((props) => [
                    (_unref(table).taxonomy < 4)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createVNode(_component_router_link, {
                            to: `${_unref(fetchNavigationUrl)}${_unref(validateInternalParameter)(
                  props.row['taxonomy_' + _unref(table).taxonomy]
                )}${tabModel === 0 ? '' : '?tab=tabular'}`
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(props.row["taxonomy_" + _unref(table).taxonomy]), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(props.row["taxonomy_" + _unref(table).taxonomy]), 1))
                  ]),
                  _: 1
                }, 8, ["field", "label"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columnSkeleton), (col, i) => {
                  return (_openBlock(), _createBlock(_component_o_table_column, {
                    key: i,
                    label: 
              col.convert
                ? col.level === 1
                  ? `${col.label} ${_unref(getBottomName)}`
                  : `${col.label} ${_unref(getTopName)}`
                : col.label
            ,
                    sortable: true,
                    visible: 
              _unref(isColumnVisible)(col.field, _unref(getMetaTableColumns)) &&
              _unref(isColumnAvailable)(
                col.field,
                _unref(currentProgram)?.program_custom_reports[0].meta.excludedColumns || []
              )
            ,
                    position: "centered",
                    class: "o-table__td--centered"
                  }, {
                    default: _withCtx((props) => [
                      _createVNode(_component_performance_field, {
                        current: 
                col.convert
                  ? col.level === 1
                    ? props.row[`${col.field}_${_unref(convertNameToHandle)(_unref(getBottomName))}`]
                    : props.row[`${col.field}_${_unref(convertNameToHandle)(_unref(getTopName))}`]
                  : props.row[col.field]
              ,
                        monetary: col.monetary,
                        rounded: col.rounded,
                        percentage: col.percentage,
                        "one-decimal": col.oneDecimal,
                        opposite: col.opposite,
                        comparing: false
                      }, null, 8, ["current", "monetary", "rounded", "percentage", "one-decimal", "opposite"])
                    ]),
                    _: 2
                  }, 1032, ["label", "visible"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "default-sort-direction", "default-sort", "onSort"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8))
      ])
    ])
  ]))
}
}

})